module.exports = __webpack_public_path__ + "img/docusign.690fb271.svg";